export const fieldLabels = {
  firstName: "First name",
  middleName: "Middle name",
  lastName: "Last name",
  telephone: "Telephone",
  email: "Email",
  line1: "Address line 1",
  line2: "Address line 2",
  line3: "Address line 3",
  line4: "Address line 4",
  postCode: "Post code",
  country: "Country",
  requestDetails: "Request Details",
  summary: "Summary",
  dateReceived: "Date Received",
  contactMethod: "Contact Method",
  sourceMethod: "Source",
  status: "Status",
  category: "Category",
  requestType: "Request Type"
};
